// src/ChevronLeftIcon.tsx
import { jsx } from "react/jsx-runtime";
var ChevronLeftIcon = ({ ...props }) => /* @__PURE__ */ jsx(
  "svg",
  {
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    children: /* @__PURE__ */ jsx("path", { d: "m15 18-6-6 6-6" })
  }
);
var ChevronLeftIcon_default = ChevronLeftIcon;

export {
  ChevronLeftIcon_default
};
